import { BLANK_TEXT } from '../../utils';

export type FieldPropsType = {
  title: string;
  content: string | number;
  ltr?: boolean;
  className?: string;
};

function Field({ title, content, ltr = false, className }: FieldPropsType) {
  return (
    <p className={className}>
      <span className='font-medium'>{title}: </span>
      <span dir={ltr ? 'ltr' : 'rtl'}>{content !== null ? content : BLANK_TEXT}</span>
    </p>
  );
}

export default Field;
